<template>
    <router-link :to="eventPageLink">
        <div class="button is-large is-fullwidth is-info">
            {{ name }}
        </div>
    </router-link>
</template>

<script>
export default {
    props: ['id', 'name', 'date'],
    computed: {
        eventPageLink() {
            return this.$route.path + "/" + this.id;
        }
    }
}
</script>